export default __webpack_public_path__ + "static/media/edit-enable.e9fc34f7.svg";